import { createSelector } from '@reduxjs/toolkit';

import { projectSelector } from 'src/selectors/project';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

const hasProjectSelector = (projectId: string) =>
  createSelector(
    projectSelector(projectId),
    (project) => project && !project.isRemoved
  );

export const useHasProject = () => {
  const { projectId } = useRouterParams();
  return useReduxSelector(hasProjectSelector(projectId));
};
